import {apiClient} from 'common/util/api-client';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {purgeFetchCache} from 'common/report/queries/utils/fetch-cache';
import {WarehouseSource} from 'common/widgets/warehouse-import-builder/types';

import {appApiUrl} from '../utils';

export type WarehouseSourcesResponse = WarehouseSource[];

function getUrl(projectId: string) {
  return appApiUrl(`warehouse-sources/sources`, {projectId});
}

export const warehouseSourcesClient: ApiResourceClient<WarehouseSourcesResponse> = {
  index() {
    throw new Error(`WarehouseSourcesClient does not support index queries`);
  },

  get(id: string) {
    return apiClient.hydratedGet<WarehouseSourcesResponse>(getUrl(id));
  },

  purgeCache(id: string) {
    purgeFetchCache({everything: true, path: getUrl(id)});
  },
};
